import React from 'react';

function PlaceholderTicketIcon(props) {
  return (
    <svg
      width="420"
      height="420"
      viewBox="0 0 420 420"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M372.342 238.668C374.09 229.044 375.002 219.128 375.002 209C375.002 117.873 301.129 44 210.002 44C136.152 44 73.633 92.5175 52.582 159.417L100.838 111.161C102.548 109.451 104.866 108.489 107.286 108.485L183.547 108.361C188.622 108.353 192.742 112.473 192.734 117.548L192.608 193.808C192.605 196.228 191.642 198.546 189.933 200.256L92.5697 297.62C88.9974 301.192 83.2005 301.187 79.6219 297.608L60.1337 278.12C86.2829 334.723 143.556 374 210.002 374C268.288 374 319.515 343.778 348.869 298.15L325.434 321.584C322.622 324.396 318.068 324.4 315.261 321.593L238.761 245.094C237.417 243.751 236.661 241.929 236.658 240.027L236.561 180.108C236.554 176.121 239.792 172.883 243.779 172.89L303.698 172.988C305.599 172.992 307.421 173.747 308.764 175.091L372.342 238.668Z"
        fill="black"
        fillOpacity="0.05"
      />
      <path
        d="M123.191 151.982C116.047 159.127 116.057 170.721 123.214 177.878C130.371 185.035 141.965 185.045 149.11 177.901C156.254 170.756 156.244 159.162 149.087 152.005C141.93 144.848 130.336 144.837 123.191 151.982Z"
        fill="black"
        fillOpacity="0.05"
      />
      <path
        d="M270.835 227.53C276.448 233.144 285.558 233.136 291.181 227.512C296.805 221.889 296.813 212.78 291.199 207.166C285.586 201.552 276.476 201.56 270.853 207.184C265.229 212.807 265.221 221.917 270.835 227.53Z"
        fill="black"
        fillOpacity="0.05"
      />
      <path
        d="M364.832 85.028C362.284 86.8659 359.144 83.7266 360.982 81.1778L375.382 61.2088C377.826 57.8186 382.716 57.4112 385.657 60.3527C388.599 63.2942 388.192 68.1837 384.801 70.6284L364.832 85.028Z"
        fill="black"
        fillOpacity="0.05"
      />
      <path
        d="M364.042 96.4995C361.801 96.1347 361.801 92.9127 364.042 92.5479L381.592 89.6899C384.572 89.2047 387.277 91.5047 387.277 94.5237C387.277 97.5427 384.572 99.8427 381.592 99.3575L364.042 96.4995Z"
        fill="black"
        fillOpacity="0.05"
      />
      <path
        d="M348.544 83.3948C348.836 85.1872 351.414 85.1872 351.706 83.3948L353.993 69.3514C354.381 66.9671 352.541 64.8027 350.125 64.8027C347.71 64.8027 345.869 66.9671 346.258 69.3513L348.544 83.3948Z"
        fill="black"
        fillOpacity="0.05"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M325.434 321.585C322.622 324.397 318.067 324.401 315.26 321.594L238.76 245.094C237.417 243.751 236.661 241.929 236.658 240.028L236.561 180.108C236.554 176.121 239.792 172.884 243.779 172.89L303.697 172.989C305.599 172.992 307.42 173.748 308.764 175.091L385.264 251.591C388.071 254.398 388.067 258.952 385.255 261.764L325.434 321.585ZM291.181 227.513C285.558 233.136 276.448 233.144 270.834 227.531C265.221 221.917 265.229 212.808 270.852 207.184C276.476 201.561 285.585 201.553 291.199 207.166C296.813 212.78 296.805 221.889 291.181 227.513Z"
        fill="black"
        fillOpacity="0.4"
      />
      <path
        d="M336.253 272.583C325.708 283.127 325.708 300.223 336.253 310.767L374.436 272.583C363.892 262.039 346.797 262.039 336.253 272.583Z"
        fill="black"
        fillOpacity="0.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.47812 221.472C-0.100478 217.894 -0.105603 212.097 3.46668 208.524L100.83 111.161C102.539 109.451 104.858 108.489 107.278 108.485L183.539 108.361C188.613 108.353 192.734 112.473 192.726 117.548L192.6 193.808C192.596 196.228 191.634 198.546 189.924 200.256L92.5614 297.62C88.9892 301.192 83.1922 301.187 79.6136 297.608L3.47812 221.472ZM123.206 177.878C116.049 170.721 116.039 159.127 123.183 151.982C130.328 144.837 141.922 144.848 149.079 152.005C156.236 159.162 156.246 170.756 149.102 177.901C141.957 185.045 130.363 185.035 123.206 177.878Z"
        fill="black"
        fillOpacity="0.6"
      />
      <path
        d="M65.8437 235.241C52.4238 221.821 30.666 221.821 17.2462 235.241L65.8437 283.839C79.2635 270.419 79.2635 248.661 65.8437 235.241Z"
        fill="black"
        fillOpacity="0.2"
      />
    </svg>
  );
}

export default PlaceholderTicketIcon;
